import * as React from 'react';
import * as i18n from 'i18next';
import { translate } from 'react-i18next';
import {
	getMenuItems,
	deleteMenuItem,
	updateMenuItemInList,
	setLanguageFilter,
	setSortFilter,
	setSearchFilter,
	setStatusFilter,
	publishMenuItem,
} from 'modules/menuitem/menuitems';
import { IMenuItemsAction, IMenuItemsData } from 'models/menuitem/menuitems';
import { IStore } from 'redux/IStore';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import { ItemCardList } from 'components';
import { ErrorPage } from 'containers';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { showModal, closeModal } from 'modules/modal';
import { IModalAction } from 'models/modal';
import { IMenuItem } from 'models/menuitem/menuitem';
import * as c from 'models/constants';
import { browserHistory, RouteProps } from 'react-router';
import { ILanguage } from 'models/common';
import { AdminMenuItemsSort } from 'models/enums/sortvalues';
import { FilteredPage } from 'components/PortalStructure';
const { connect } = require('react-redux');
import { IUserPreferences } from 'models/user/userpreferences';
import { MenuItemType } from 'models/enums/menuitemtype';
import { getMenuItemTypeByPathname } from 'helpers/common';

interface IProps {
	menuItemsData?: IMenuItemsData;
	userPreferences?: IUserPreferences;
	languageDomainValues?: ILanguage[];
	route?: RouteProps;
	location?: any;
	getMenuItems?: (menuItemType: MenuItemType) => IMenuItemsAction;
	deleteMenuItem?: (itemId: string) => IMenuItemsAction;
	updateMenuItemInList?: (menuItem: IMenuItem) => IMenuItemsAction;
	setSortFilter?: (sortFilter: number) => IMenuItemsAction;
	setSearchFilter?: (keywordFilter: string) => IMenuItemsAction;
	setLanguageFilter?: (languageKeyFilter: string) => IMenuItemsAction;
	setStatusFilter?: (statusFilter: string) => IMenuItemsAction;
	publishMenuItem?: (itemId: string, languageKey: number) => IMenuItemsAction;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	t?: (key: string) => string;
}

interface IMenuItemsItemCardList extends IItemCardList {
	publishItem?: (itemId: string, languageKey: number) => void;
}

@connect(
	(state: IStore) => ({
		menuItemsData: state.menuItems,
		userPreferences: state.userPreferences,
		languageDomainValues: state.domainValues.languages,
	}),
	(dispatch) => ({
		getMenuItems: (menuItemType: MenuItemType) => dispatch(getMenuItems(menuItemType)),
		deleteMenuItem: (itemId: string) => dispatch(deleteMenuItem(itemId)),
		updateMenuItemInList: (menuItem: IMenuItem) => dispatch(updateMenuItemInList(menuItem)),
		publishMenuItem: (itemId: string, languageKey: number) => dispatch(publishMenuItem(itemId, languageKey)),
		closeModal: () => dispatch(closeModal()),
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
		setLanguageFilter: (languageKey: string) => dispatch(setLanguageFilter(languageKey)),
		setSortFilter: (sort: number) => dispatch(setSortFilter(sort)),
		setSearchFilter: (keyword: string) => dispatch(setSearchFilter(keyword)),
		setStatusFilter: (status: string) => dispatch(setStatusFilter(status)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class MenuItems extends React.Component<IProps> {
	private menuItemType: MenuItemType;
	public menuItemsInnerHolder: HTMLElement = undefined;
	private searchValue: string = '';

	constructor(props) {
		super(props);

		this.handleEditItem = this.handleEditItem.bind(this);
		this.publishItem = this.publishItem.bind(this);
		this.openDeleteMenuItem = this.openDeleteMenuItem.bind(this);
		this.deleteMenuItem = this.deleteMenuItem.bind(this);
		this.loadMoreData = this.loadMoreData.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.cancelClick = this.cancelClick.bind(this);

		this.handleLanguageChange = this.handleLanguageChange.bind(this);
		this.handleSortChange = this.handleSortChange.bind(this);
		this.handleSearchValueChange = this.handleSearchValueChange.bind(this);
		this.handleSearchMenuItems = this.handleSearchMenuItems.bind(this);
		this.handleSearchEnterPress = this.handleSearchEnterPress.bind(this);
	}

	public componentDidMount() {
		this.menuItemType = getMenuItemTypeByPathname(this.props.location.pathname);
		this.props.setStatusFilter(this.props.route.path);
		this.props.getMenuItems(this.menuItemType);
	}

	public componentDidUpdate(prevProps: IProps) {
		if (
			prevProps.route.path !== this.props.route.path ||
			(prevProps.route.path === this.props.route.path && prevProps.location.pathname !== this.props.location.pathname)
		) {
			this.menuItemType = getMenuItemTypeByPathname(this.props.location.pathname);
			this.props.setStatusFilter(this.props.route.path);
			this.props.getMenuItems(this.menuItemType);
		}

		if (
			this.searchValue.length === 0 &&
			this.props.menuItemsData.keywordFilter &&
			this.props.menuItemsData.keywordFilter.length > 0
		) {
			this.searchValue = this.props.menuItemsData.keywordFilter;
		}
	}

	public handleEditItem(code: string) {
		if (this.menuItemType === MenuItemType.Portal) {
			browserHistory.push('/admin/portal/pages/edit/' + code);
		} else if (this.menuItemType === MenuItemType.Magazine) {
			browserHistory.push('/admin/magazine/pages/edit/' + code);
		}
	}

	public publishItem(itemId: string, languageKey: number) {
		this.props.publishMenuItem(itemId, languageKey);
	}

	private openDeleteMenuItem(_, itemId: string) {
		const dialogContent = (
			<div className="confirmationDialogModal__contentContainer">
				<img src={require('containers/Html/icons/icon_notification.png')} />
				<h2>{i18n.t('BSPortal_Common_ConfirmationDialog_Sure')}</h2>
				<p>{i18n.t('Administration_MenuItem_MenuItems_DeleteModal_AboutDelete')}</p>
				<p>{i18n.t('BSPortal_Common_ConfirmationDialog_Confirm')}</p>
			</div>
		);

		this.props.showModal('ConfirmationDialog', {
			confirmAction: this.deleteMenuItem,
			value: itemId,
			yesButtonText: i18n.t('BSPortal_Common_YesDelete'),
			noButtonText: i18n.t('BSPortal_Common_NoWait'),
			content: dialogContent,
			closeModal: this.props.closeModal,
		});
	}

	private deleteMenuItem(confirm: boolean, itemId: string) {
		if (confirm) {
			this.props.deleteMenuItem(itemId);
		}
		this.props.closeModal();
	}

	private cancelClick() {
		browserHistory.push('/');
	}

	public closeModal() {
		this.props.closeModal();
	}

	public loadMoreData() {
		this.props.getMenuItems(this.menuItemType);
	}

	public handleLanguageChange(value: string) {
		this.props.setLanguageFilter(value);
		this.props.getMenuItems(this.menuItemType);
	}

	public handleSortChange(value: number) {
		this.props.setSortFilter(value);
		this.props.getMenuItems(this.menuItemType);
	}

	private handleSearchValueChange(value: string) {
		this.props.setSearchFilter(value);
	}

	private handleSearchMenuItems() {
		this.props.getMenuItems(this.menuItemType);
	}

	private handleSearchEnterPress() {
		this.props.getMenuItems(this.menuItemType);
	}

	/* RENDER */
	public render() {
		if (this.props.menuItemsData.error) {
			return <ErrorPage {...this.props} message={this.props.menuItemsData.message} />;
		}

		const { keywordFilter, languageKeyFilter, sortFilter } = this.props.menuItemsData;
		const { t } = this.props;

		const menuItems: IMenuItem[] = [];

		let searchFilter: string = keywordFilter;
		if (!searchFilter) {
			searchFilter = '';
		}

		if (this.props.menuItemsData !== undefined || this.props.menuItemsData !== null) {
			this.props.menuItemsData.items.forEach((item) => {
				if (item.pageJObject.menuType === c.MENU_TYPE_PAGE) {
					menuItems.push(item);
				}
			});
		}

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: menuItems.length,
			next: this.loadMoreData,
			hasMore: menuItems.length > menuItems.length,
			loader: <h4>{t('BSPortal_Common_Loading')} </h4>,
		};

		const listProps: IMenuItemsItemCardList = {
			items: menuItems || [],
			itemType: c.NODE_TYPE_ADMIN_MENU_ITEM_CARD,
			isInfiniteScroll: true,
			infiniteScrollProps,
			useIntersectionObserver: true,
			editItem: this.handleEditItem,
			deleteItem: this.openDeleteMenuItem,
			publishItem: this.publishItem,
			currentUserId: this.props.userPreferences.id,
			currentUserIsAdministrator: this.props.userPreferences.isAdministrator,
			currentUserIsEditor: this.props.userPreferences.isEditor,
		};

		let languageOptions = [];
		if (this.props.languageDomainValues.length > 0) {
			languageOptions = this.props.languageDomainValues.map((language: ILanguage) => {
				return {
					key: language.key,
					value: language.value,
				};
			});
		}

		const sortOptions = [];
		for (const n in AdminMenuItemsSort) {
			if (typeof AdminMenuItemsSort[n] === 'number') {
				sortOptions.push({ key: AdminMenuItemsSort[n], value: t('Administration_MenuItem_MenuItems_Sort_' + n) });
			}
		}

		const topBarProps: object = {
			searchKeyword: keywordFilter,
			leftFilterTitle: t('BSPortal_Common_Filter_Language'),
			leftFilterKey: languageKeyFilter,
			leftFilterOptions: languageOptions,
			rightFilterTitle: t('BSPortal_Common_Filter_SortBy'),
			rightFilterOptions: sortOptions,
			rightFilterKey: sortFilter,
			onSearchButtonClick: this.handleSearchMenuItems,
			onSearchEnterPress: this.handleSearchEnterPress,
			onSearchValueChange: this.handleSearchValueChange,
			onRightFilterChange: this.handleSortChange,
			onLeftFilterChange: this.handleLanguageChange,
		};

		return (
			<FilteredPage filterBarOptions={topBarProps}>
				<div className="menu-items-header">
					<div className="title">{t('Administration_MenuItem_ManageMenuItem_Label_Title')}</div>
					<div className="published">{t('Administration_MenuItem_ManageMenuItem_Label_Published')}</div>
					<div className="created-date">{t('AdminMenuItemCard_Label_CreatedOn')}</div>
					<div className="expires-date">{t('AdminMenuItemCard_Label_ExpiresOn')}</div>
					<div className="control"></div>
				</div>
				<ItemCardList {...listProps} />
			</FilteredPage>
		);
	}
}
export { MenuItems };
